import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIcon } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ListDropDownComponent } from '@src/suite/common/components/list-drop-down/list-drop-down';
import { StoryItemComponent } from '@src/suite/common/components/stories-list/story-item/story-item';
import { StTopicItemComponent } from '@src/suite/common/components/topic-item/st-topic-item.component';
import { ObjectTypes } from '@src/suite/common/enums/object-types';
import { StLiveCardItemComponent } from '@src/suite/live/components/st-live-card-item/st-live-card-item.component';

import { BaseViewOptionsComponent } from '../base-view-options.component';

@Component({
    selector: 'st-wastebin-view-options',
    imports: [
        ListDropDownComponent,
        MatButton,
        MatButtonModule,
        MatButtonToggleModule,
        MatIcon,
        MatListModule,
        MatMenuModule,
        MatTooltipModule,
        StLiveCardItemComponent,
        StoryItemComponent,
        StTopicItemComponent,
    ],
    templateUrl: './wastebin-view-options.component.html',
    styleUrl: './wastebin-view-options.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-wastebin-view-options',
    },
})
export class WastebinViewOptionsComponent extends BaseViewOptionsComponent {
    objectTypesEnum = ObjectTypes;
}
